import { msg } from '..'
import { length } from './length'

const OFFSET_ASCII = 48
const DIVISOR_MODULO_11 = 11
const TAMANHO_BASE_CNPJ = 12
const PESOS_DV1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
const PESOS_DV2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

function cnpjRule(value: string) {
  if (!isValid(value)) {
    return msg('invalid', value)
  }
}

function calcularDigitoVerificador(cnpj: string, pesos: number[], tamanhoConsiderado: number): number {
  let soma = 0
  for (let i = 0; i < tamanhoConsiderado; i++) {
    soma += (cnpj.charCodeAt(i) - OFFSET_ASCII) * pesos[i]
  }
  const resto = soma % DIVISOR_MODULO_11
  return resto < 2 ? 0 : DIVISOR_MODULO_11 - resto
}

function isValid(cnpjValue: string) {
  if (!cnpjValue) return true

  const cnpjLimpo = cnpjValue.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()

  if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpjLimpo)) return false

  if (/^(.)\1+$/.test(cnpjLimpo)) return false

  const dv1Informado = Number.parseInt(cnpjLimpo.charAt(12), 10)
  const dv2Informado = Number.parseInt(cnpjLimpo.charAt(13), 10)

  const dv1Calculado = calcularDigitoVerificador(cnpjLimpo, PESOS_DV1, TAMANHO_BASE_CNPJ)
  const dv2Calculado = calcularDigitoVerificador(cnpjLimpo, PESOS_DV2, TAMANHO_BASE_CNPJ + 1)

  return dv1Calculado === dv1Informado && dv2Calculado === dv2Informado
}

export const cnpj = [length(14), cnpjRule]
